import Vue from 'vue'

const mixin = {
    computed: {
        $breakpoint() {
            return this.$store.state.global.appBreakPoint
        },
    },
}

Vue.mixin(mixin)
